module.exports = __webpack_public_path__ + "img/sponsors.ba6a835c.svg";